import { createSelectionListViewComponent } from 'factories/SelectionListView'
import { getSessionItem, updateSessionItem } from 'helpers/sessionStorage'
import { getStorageKey } from '.'

export default createSelectionListViewComponent({
  pageTitleLanguageKey: 'priority',
  getItemSize: () => 45,
  allowSearch: () => false,
  getValue: () => getSessionItem(getStorageKey(), {}).item?.priority,
  getOnChange: (self) => (each) =>
    updateSessionItem(getStorageKey(), {}, (draft) => {
      draft.item.priority = each.id
    }),
})()
